import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const ProductDetails = () => {
  const { productId } = useParams(); // Get product ID from URL
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true); // Add a loading state
  const [mainImage, setMainImage] = useState(""); // State for main image

  useEffect(() => {
    fetch(`https://admin.leapatinternational.com/get_products_details.php?product_id=${productId}`)
      .then((response) => response.json())
      .then((data) => {
        setProduct(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching product details:", error);
        setLoading(false);
      });
  }, [productId]);

  if (loading) {
    return <div>Loading...</div>; // Show a loading message
  }

  if (!product) {
    return <div>No product found.</div>; // Handle no data case
  }
  return (
       <div>
                {/* Spinner Start */}
               
                {/* Spinner End */}
            

            
                <div class="container">
       
                <div className="product-container">
      {/* Left Section - Images */}
      <div className="product-images">
      <div className="thumbnail-images">
        {product.images.map((img, index) => {
          const imageUrl = `https://admin.leapatinternational.com/assets/images/product/${img}`;
          return (
            <img 
              key={index} 
              src={imageUrl} 
              alt={`Thumbnail ${index + 1}`} 
              onClick={() => setMainImage(imageUrl)} // Change main image on click
              className="thumbnail"
              style={{ cursor: "pointer", border: mainImage === imageUrl ? "2px solid #000" : "none" }}
            />
          );
        })}
      </div>
      <div className="main-image">
        <img src={mainImage || `${product.main_image}`} alt={product.title} />
      </div>
    </div>

      {/* Right Section - Details */}
      <div className="product-details">
        <h1 className="product-title">{product.product_name}</h1>
        <p className="product-description" dangerouslySetInnerHTML={{ __html: product.description }}></p>


        {/* Specification Table */}
        

        {/* 360° View Button */}
       
      </div>

      {/* Features Section */}
      <div className="features-section">
        <h2>Features</h2>
        <div className="features-grid">
          <div className="feature-item">
            <img src="/assets/img/dur.png" alt="Highly Durable" />
            <p>Highly Durable</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/water.png" alt="Waterproof" />
            <p>Waterproof</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/stain.png" alt="Stain-Resistant" />
            <p>Stain-Resistant</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/scratch.png" alt="Soundproof" />
            <p>Scratch-Resistant</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/impact.png" alt="Soundproof" />
            <p>Impact-Resistant</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/sound.png" alt="Soundproof" />
            <p>Soundproof</p>
          </div>

          <div className="feature-item">
            <img src="/assets/img/easy.png" alt="Highly Durable" />
            <p>Easy to Clean</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/hyg.png" alt="Waterproof" />
            <p>Hygienic Surface</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/env.png" alt="Stain-Resistant" />
            <p>Environmentally Friendly</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/auth.png" alt="Soundproof" />
            <p>Authentic Appearance</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/eq.png" alt="Soundproof" />
            <p>Easy & Quick Installation</p>
          </div>
          <div className="feature-item">
            <img src="/assets/img/low.png" alt="Soundproof" />
            <p>Low Maintenance</p>
          </div>


        </div>
      </div>
    </div>


                </div>
            
           
            <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
                <i className="bi bi-arrow-up"></i>
              </a>
          
          
                {/* Optional: Add any other content or components here */}
            
                <style>
                  {`
                    /* Add your custom CSS here */
                    .service-item-top {
                      transition: transform 0.3s ease-in-out;
                    }
            
                    .service-item-top:hover {
                      transform: scale(1.05);
                    }
                .product-container {
  display: flex;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top:135px;
}

.product-images {
  width: 40%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.thumbnail-images img {
  width: 60px;
  height: 80px;
  margin-right: 8px;
  cursor: pointer;
  border: 2px solid #ddd;
}

.main-image img {
  width: 100%;
  max-width: 400px;
  border-radius: 5px;
}

.product-details {
  width: 55%;
  padding: 20px;
}

.series {
  font-size: 14px;
  color: #777;
  text-transform: uppercase;
}

.product-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 10px;
}

.product-description {
  font-size: 16px;
  color: #555;
  line-height: 1.5;
}

.spec-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.spec-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.view-btn {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  margin-top: 10px;
}

.features-section {
  width: 100%;
  margin-top: 40px;
}

.features-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.feature-item {
 flex: 0 0 16.666667%;
  max-width: 16.666667%;
  -webkit-box-flex: 0;
  text-align: center;
}

.feature-item img {
  width: 50px;
  height: 50px;
  margin-bottom: 5px;
}

                    /* Add any additional styling you want */
                  `}
                </style>
              </div>
  );
};

export default ProductDetails;
